import { SearchX } from "lucide-react"
import { Button } from "@/components/ui/button"

interface EmptyStateProps {
  title?: string
  actionLabel?: string
  onAction?: () => void
  icon?: React.ReactNode
}

const EmptyState = ({ title = "No Data Found", actionLabel, onAction, icon }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center gap-4 justify-center py-16 px-4 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex flex-col items-center gap-3">
        <div className="relative group cursor-default">
          <div className="absolute inset-0 bg-primary-50 rounded-full scale-[1.8] opacity-20 group-hover:scale-[2.2] transition-transform duration-700 ease-out" />
          <div className="absolute inset-0 bg-primary-50 rounded-full scale-[1.4] opacity-40 group-hover:scale-[1.6] transition-transform duration-500 ease-out" />
          <div className="relative bg-white p-4 rounded-full ring-1 ring-gray-100 shadow-sm group-hover:shadow-md transition-all duration-300">
            {icon || <SearchX className="h-8 w-8 text-gray-400 group-hover:text-primary-500 transition-colors duration-300" />}
          </div>
        </div>

        <div className="text-center">
          <h3 className="text-lg font-semibold text-gray-900 mb-1 tracking-tight">{title}</h3>
          <p className="text-sm text-gray-500 text-center max-w-sm leading-relaxed">Data not found or try adjusting your filters or search query to find what you&apos;re looking for.</p>
        </div>
      </div>

      {actionLabel && onAction && (
        <Button onClick={onAction} size="sm" variant="outline" className="rounded-full px-6 border-gray-200 hover:bg-gray-50 hover:text-gray-900 transition-all active:scale-95">
          {actionLabel}
        </Button>
      )}
    </div>
  )
}

export default EmptyState
